import { Image } from '@smartgift/frontend-toolkit';
import styled from 'styled-components';

const TableProducts = styled.div`
  align-items: center;
  cursor: pointer;
  display: flex;
  gap: 4px;
  overflow: hidden;

  ${Image.S.Image} {
    border: 1px solid var(--color-components-input-border-default);
    border-radius: var(--size-border-radius-md);
  }
`;

const TableProductsLength = styled.button`
  align-items: center;
  background-color: var(--color-bg-weaker);
  border: 1px solid var(--color-components-input-border-default);
  border-radius: var(--size-border-radius-md);
  color: var(--color-fg-weakest);
  cursor: pointer;
  display: flex;
  font-weight: 600;
  justify-content: center;
`;

export { TableProducts, TableProductsLength };
